import "./style.scss";

const RegisteredActivities = ({ action, icon, text }) => {
  return (
    <>
      <div className="reg-activity-icon" onClick={action}>
        <div className="category-image">{icon}</div>
        <div className="caregory-name">
          <span>{text}</span>
        </div>
      </div>
    </>
  );
};

export default RegisteredActivities;
